import { render, staticRenderFns } from "./trend-chart.vue?vue&type=template&id=1052728a&"
import script from "./trend-chart.vue?vue&type=script&lang=js&"
export * from "./trend-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports